import { Col, Row, TabControl, Text } from 'components';
import { useTranslation } from 'react-i18next';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Header } from 'screens/Admin/components';
import SubscriptionPlansTab from '../SubscriptionPlans';
import CampaignsTab from '../SubscriptionPlans/campaigns';
import { Churn, Mrr, Overview, Subscribers } from '../Subscriptions/components';

export const SUBSCRIPTION_TABS = ['overview', 'mrr', 'churn', 'subscribers', 'plans', 'campaigns'];

const TAB_LABEL_KEYS = {
  overview: 'subscriptions.admin.tabs.overview',
  mrr: 'subscriptions.admin.tabs.mrr',
  churn: 'subscriptions.admin.tabs.churn',
  subscribers: 'subscriptions.admin.tabs.subscribers',
  plans: 'subscription.admin.tabs.plans',
  campaigns: 'subscription.admin.tabs.campaigns'
};

const TAB_CONTENT = {
  overview: Overview,
  mrr: Mrr,
  churn: Churn,
  subscribers: Subscribers,
  plans: SubscriptionPlansTab,
  campaigns: CampaignsTab
};

const resolveTab = (value, fallback = SUBSCRIPTION_TABS[0]) =>
  SUBSCRIPTION_TABS.includes(value) ? value : fallback;

const Subscription = () => {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const tab = resolveTab(params.get('tab'));
  const Content = TAB_CONTENT[tab];

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center between wid="100%">
          <Text h3>{t('admin.nav.subscription')}</Text>
        </Row>
      </Header>

      <Col start noFlex wid="100%" className="mt-[54px] h-[calc(100vh-54px)] overflow-y-auto">
        <TabControl
          options={SUBSCRIPTION_TABS.map((key) => t(TAB_LABEL_KEYS[key]))}
          selectedIdx={SUBSCRIPTION_TABS.indexOf(tab)}
          handleSelect={(idx) => setParams({ tab: SUBSCRIPTION_TABS[idx] })}
        />
        <Content />
      </Col>
    </Col>
  );
};

/** Old /admin/subscription-plans and /admin/subscriptions addresses land on the matching tab. */
export const SubscriptionRedirect = ({ defaultTab }) => {
  const [params] = useSearchParams();
  const tab = resolveTab(params.get('tab'), defaultTab);
  return <Navigate to={`/admin/subscription?tab=${tab}`} replace />;
};

export default Subscription;
